import styled from 'styled-components'

export const inputFontSize = '14px'

export const StyledAddressModal = styled.div`
  div label {
    font-weight: 600;
  }

  input {
    min-height: 30px;
    font-size: ${inputFontSize};
    :focus {
      background-color: #fff;
      border-color: ${({ theme }) => theme.colors.inputBorder};
      outline: 0;
    }
    /* box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25); */
  }

  .required-field:after {
    content: '*';
    color: ${({ theme }) => theme.colors.dangerColor};
    margin-left: 0.2rem;
  }

  .save-option {
    margin-top: 1rem;
    input {
      min-width: 16px;
      min-height: 16px;
      margin-right: 10px;
      cursor: pointer;
    }

    label {
      font-weight: normal;
      cursor: pointer;
    }

    .col-sm-12 {
      margin-top: 5px;
      font-size: 15px;
      display: flex;
    }
  }

  .form-text {
    font-size: 1.2rem;
    font-weight: bold;
  }

  .button-group {
    margin-top: 0.4rem;
    display: flex;
    .btn {
      width: 16rem;
    }
  }
`
